<template>
  <div className="sepa-list tab-table">
    <sepa-table />
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import SepaTable from "../../../sepa/SepaTable.vue";

  const {mapActions: settlementsMapActions} = createNamespacedHelpers('sepa');
  const {mapState} = createNamespacedHelpers('sales');

  export default {
    name: "SepaList",
    components: {SepaTable},
    data() {
      return {
      }
    },
    computed: {
      ...mapState({
        sale: state => state.view.currentSale
      })
    },
    methods: {
      ...settlementsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'sale',
        sale: this.sale,
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
